export default () => ({
  header: {
    position: 'sticky',
    go_to_site: false,
  },
});
